import React from "react";
import logo from "./images/logo_2.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />

        <p style={{ color: "green", fontSize: "64px" }}>Homepage</p>
        <p style={{ color: "green" }}> ... *** Coming soon *** ....</p>
      </header>
    </div>
  );
}

export default App;
